'use strict';

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _themeCurrency = require('@shopify/theme-currency');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.load)('*');

document.addEventListener('cart', loadCart, false);

if ((0, _jquery2.default)('body').hasClass('template-cart')) {
    loadCart();
}

function loadCart() {

    var cart_count = (0, _jquery2.default)('.barba-container[data-namespace="cart"]').data('cart-count');

    cart.getState().then(function (state) {
        //console.log(`Cart State: ${state.item_count}`);
        var money = (0, _themeCurrency.formatMoney)(state.total_price, theme.moneyFormat);
        money = money.split('.00').join('');

        (0, _jquery2.default)('.cart-total').text(money);

        if (cart_count < state.item_count) {
            (0, _jquery2.default)('.cart-items').html('');

            for (var i = 0; i < state.items.length; i++) {
                var item = state.items[i];
                console.log(item);
                var author = item.title;
                var price = item.price;
                var title = item.title;
                for (var j = 0; j < product_info.length; j++) {
                    if (item.handle == product_info[j].handle) {
                        author = product_info[j].author;
                        price = product_info[j].price;
                        title = product_info[j].title;
                        break;
                    }
                }

                var forloop_index = i + 1;

                var $li = '<li>\n                    <div class="item-count">\n                    <input type="number" name="updates[]" id="updates_' + item.key + '" value="' + item.quantity + '" min="0" class="qty-input" data-id="' + item.key + '" aria-label="Item quantity">\n                    </div>\n                    <div class="item-x">\n                        <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                            <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->\n                            <desc>Created with Sketch.</desc>\n                            <defs></defs>\n                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">\n                                <path d="M0.5,0.5 L11.5,11.5" id="Line" stroke="#000000" stroke-width="0.5"></path>\n                                <path d="M0.5,0.5 L11.5,11.5" id="Line" stroke="#000000" stroke-width="0.5" transform="translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "></path>\n                            </g>\n                        </svg>\n                    </div>\n                    <div class="item-info">\n                    <a href="' + item.url + '" title="' + title + '">\n                    <h3>' + title + '</h3>\n                    <p class="product-author">' + author + '</p>\n                    </a>\n                    <div class="item-actions">\n                        <p>' + price + '</p>\n                        <a class="no-barba" href="/cart/change?line=' + forloop_index + '&amp;quantity=0">remove</a>\n                    </div>\n                    </div>\n                </li>';

                (0, _jquery2.default)('.cart-items').append($li);
            }
        }
    });

    (0, _jquery2.default)('.qty-input').unbind('change paste').bind('change paste', function (e) {
        e.stopPropagation();
        var $val = (0, _jquery2.default)(this).val();
        console.log($val);
        if ($val > 0) {
            changeQuantity((0, _jquery2.default)(this));
        } else {
            (0, _jquery2.default)(this).val(1);
        }
    });
}

function changeQuantity($input) {

    var key = $input.data('id'),
        qty = Number($input.val());

    cart.updateItem(key, { quantity: qty }).then(function (state) {
        var item = state.items.find(function (item) {
            return item.key === key;
        });
        console.log('The item with key \'' + key + '\' now has quantity ' + item.quantity);
        window.location = '/cart';
    });
}